import { AxiosResponse } from 'axios'
import { EmptyApiResult, ApiErrorDto } from '../api'
import { useApiClient } from './useApiClient'
import React from 'react'

const buildErrorMessage = (error: any) => {
  if (!error) return ''

  if (typeof error === 'string') {
    return error
  } else if (error.message) {
    return error.message
  }

  return ''
}

export const useLogger = () => {
  const apiClient = useApiClient()

  const logError = React.useMemo(
    () => (error: any, ...optionalParams: any[]) => {
      console.error(error, optionalParams)

      const data: ApiErrorDto = {
        message: buildErrorMessage(error),
        stackInfo: error?.stack ?? '',
        url: window.location.href,
      }

      return apiClient.request<void, AxiosResponse<EmptyApiResult>>({
        url: 'api/error',
        method: 'post',
        data,
        withCredentials: true,
      })
    },
    [buildErrorMessage],
  )

  return {
    logError,
  }
}
